import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "animated fadeIn" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "card border-top-2 border-top-info col-md-8 offset-md-2" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"text-center\"><img class=\"navbar-brand-full\" src=\"img/logo.png\" height=\"100\" alt=\"LO Logo\"><h2>Learning Online Registration</h2></div><ul class=\"step d-flex flex-nowrap pt-4\"><li class=\"step-item\"><span>Step 1<br>Student registers</span></li><li class=\"step-item active\"><span>Step 2<br>Student &amp; parent/guardian agree to appropriate policy documents</span></li><li class=\"step-item\"><span>Step 3<br>Student enrollments will be reviewed and approved</span></li><li class=\"step-item\"><span>Step 4<br>Student will be enrolled into classes</span></li></ul>", 2)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-4" }, "Forms", -1)
const _hoisted_8 = { class: "mt-3 mb-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:learningonline@rcsd.ca" }, "learningonline@rcsd.ca", -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["data"]
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "Your browser does not support PDFs", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "text-right" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "form-group col" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("u", { class: "text-success" }, "agreement", -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 0,
  class: "form-group col"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("To indicate your "),
    /*#__PURE__*/_createElementVNode("u", { class: "text-danger" }, "disagreement"),
    /*#__PURE__*/_createTextVNode(" to the above please enter your email address below. Use the same email address where you received the link for this page.")
  ])
], -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "form-group col" }
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-tooltip" }, "This field is required", -1)
const _hoisted_28 = {
  key: 0,
  class: "form-group col"
}
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-tooltip" }, "This field is required", -1)
const _hoisted_31 = { class: "d-grid gap-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h5", { class: "mt-5 text-center" }, " There are no forms that require your signature. ", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-5 text-center" }, " Thank you! Your signature on these forms has been recorded. ", -1)

import axios from "axios";
import axiosdb from "@/axios-db";
import axiosaux from "@/axios-aux";
import { jsonToGraphQLQuery, EnumType } from "json-to-graphql-query";
import { onMounted, ref } from "vue";
import LoadingModal from "@/shared/LoadingModal.vue";
import ErrorModal from "@/shared/ErrorModal.vue";
import { useToast } from "vue-toast-notification";
import { useRoute } from "vue-router";
import { BButton, BCol, BRow } from "bootstrap-vue-next";
// Instance Variables

export default /*#__PURE__*/_defineComponent({
  __name: 'Forms',
  setup(__props) {

const toast = useToast();
const route = useRoute();
// Component Variables
const apiURL = ref(axiosaux.defaults.baseURL);
const dataLoaded = ref<boolean>(false);
const specificError = ref("");
const forms = ref<any[]>([]);
const ipInfo = ref({});
const userAgent = ref("");
const confirmed = ref(false);
const cipher = ref();
// Modals
const loadingVisible = ref<boolean>(false);
const errorVisible = ref<boolean>(false);

function toGQL(queryObject, variables = {}) {
  // Using the jsonToGraphQuery library to convert the json defined query into a graphQL query
  return { query: jsonToGraphQLQuery(queryObject), variables: variables };
}

async function loadData() {
  loadingVisible.value = true;

  let query = {
    query: {
      halo_form_find_forms: {
        __args: {
          cipher: cipher.value,
        },
        results: true,
      },
    },
  };

  let res = await axiosdb.post(
    "/graphql?t=" + new Date().valueOf(),
    toGQL(query)
  );

  if (res.data.errors) {
    specificError.value = res.data.errors[0].message;
    loadingVisible.value = false;

    errorVisible.value = true;
  } else {
    dataLoaded.value = true;
    forms.value = res.data.data.halo_form_find_forms.results;
  }
  loadingVisible.value = false;
}

async function sign() {
  let emails: any[] = [];
  // Ensure that all forms have been signed
  for (let form of forms.value) {
    if (!(form.agreeSignature || form.disagreeSignature)) {
      toast.error("Please read and sign the '" + form.form.title + "' form");
      return false;
    }
    if (form.agreeSignature && form.disagreeSignature) {
      toast.error(
        "Please fill in either the agreement or disagreement box, not both, for the '" +
          form.form.title +
          "' form"
      );
      return false;
    }
    // Collect each signature so we can make sure they are the same
    form.agreeSignature ? emails.push(form.agreeSignature) : null;
    form.disagreeSignature ? emails.push(form.disagreeSignature) : null;
  }
  // If they are not the same the we have a problem
  if (!emails.every((val, i, arr) => val === arr[0])) {
    toast.error("All email addresses must be the same");
    return false;
  }

  let signatures = forms.value.map((a) => {
    let agreedTo = a.agreeSignature ? true : false;
    let email = a.agreeSignature ? a.agreeSignature : a.disagreeSignature;
    return {
      id: a.id,
      cipher: cipher.value,
      agreed_to: agreedTo,
      email: email,
      ip_info: ipInfo.value,
      user_agent: userAgent.value,
    };
  });

  loadingVisible.value = true;

  let mutation = {
    mutation: {
      halo_form_sign: {
        __args: {
          signatures: signatures,
        },
        student_id: true,
      },
    },
  };

  let res = await axiosdb.post(
    "/graphql?t=" + new Date().valueOf(),
    toGQL(mutation)
  );

  if (res.data.errors) {
    toast.error(res.data.errors[0].message);
  } else {
    confirmed.value = true;
  }
  loadingVisible.value = false;
}

function onMount() {
  cipher.value = route.params.cipher;
  loadData();
  userAgent.value = navigator.userAgent;
  axios
    .get(
      "https://api.ipdata.co/?api-key=f4b7457e529350738be6ec6e88c917471da225b4921b92e222b1197d"
    )
    .then((response) => {
      ipInfo.value = response.data;
    });
}

onMounted(onMount);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_unref(BRow), null, {
            default: _withCtx(() => [
              (dataLoaded.value && !confirmed.value && forms.value.length > 0)
                ? (_openBlock(), _createBlock(_unref(BCol), { key: 0 }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createElementVNode("p", _hoisted_8, [
                        _createTextVNode(" There are " + _toDisplayString(forms.value.length) + " forms(s) that require your attention. All of these must be signed before the student can begin their course(s). The form is valid for the school year specified. If you have any questions or concerns regarding the statements or documents please contact ", 1),
                        _hoisted_9,
                        _createTextVNode(". Information about your web browser and IP address are collected by this page. ")
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(forms.value, (form, key) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: key,
                          class: "mb-5"
                        }, [
                          _createElementVNode("h4", null, _toDisplayString(form.form.title) + " - " + _toDisplayString(form.school_year.name) + " - " + _toDisplayString(form.student.first_name) + " " + _toDisplayString(form.student.last_name), 1),
                          (form.form.file)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("object", {
                                  class: "w-100",
                                  height: 500,
                                  data: apiURL.value + form.form.file.path,
                                  type: "application/pdf"
                                }, [
                                  _createElementVNode("iframe", {
                                    class: "w-100",
                                    height: 500,
                                    src: apiURL.value + form.form.file.path + '#toolbar=0'
                                  }, _hoisted_14, 8, _hoisted_12)
                                ], 8, _hoisted_11),
                                _createElementVNode("p", _hoisted_15, [
                                  _createElementVNode("a", {
                                    href: apiURL.value + form.form.file.path
                                  }, "Download a copy", 8, _hoisted_16)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("p", null, _toDisplayString(form.form.body), 1),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("label", null, [
                                _createElementVNode("b", null, [
                                  _createTextVNode("To indicate your "),
                                  _hoisted_19,
                                  _createTextVNode(" to the above please enter your email address below. Use the same email address where you received the link for this page. "),
                                  (form.form.agreement_required)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Your agreement to the above is required for enrollment into this course."))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            (!form.form.agreement_required)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control text-center border",
                                "onUpdate:modelValue": ($event: any) => ((form.agreeSignature) = $event)
                              }, null, 8, _hoisted_26), [
                                [_vModelText, form.agreeSignature]
                              ]),
                              _hoisted_27
                            ]),
                            (!form.form.agreement_required)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control text-center border",
                                    "onUpdate:modelValue": ($event: any) => ((form.disagreeSignature) = $event)
                                  }, null, 8, _hoisted_29), [
                                    [_vModelText, form.disagreeSignature]
                                  ]),
                                  _hoisted_30
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_unref(BButton), {
                          class: "btn-block text-white",
                          variant: "success",
                          onClick: sign
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Submit")
                          ], undefined, true),
                          _: 1
                        })
                      ])
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (dataLoaded.value && !confirmed.value && forms.value.length == 0)
                ? (_openBlock(), _createBlock(_unref(BCol), { key: 1 }, {
                    default: _withCtx(() => [
                      _hoisted_32
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (confirmed.value)
                ? (_openBlock(), _createBlock(_unref(BCol), { key: 2 }, {
                    default: _withCtx(() => [
                      _hoisted_33
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], undefined, true),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(LoadingModal, { visible: loadingVisible.value }, null, 8, ["visible"]),
    _createVNode(ErrorModal, { visible: errorVisible.value }, null, 8, ["visible"])
  ]))
}
}

})